(() => {
  if (window.emaMppPdpFixesLoaded) return;
  window.emaMppPdpFixesLoaded = true;

  const originalFetch = window.fetch ? window.fetch.bind(window) : null;
  if (originalFetch) {
    window.fetch = (input, init = {}) => {
      const url = typeof input === "string" ? input : input && input.url;
      if (!url || !String(url).includes("api.monpapierpeint.com/crop")) {
        return originalFetch(input, init);
      }

      const controller = new AbortController();
      const existingSignal = init && init.signal;
      const abortFromExisting = () => controller.abort();
      if (existingSignal) {
        if (existingSignal.aborted) {
          controller.abort();
        } else {
          existingSignal.addEventListener("abort", abortFromExisting, { once: true });
        }
      }

      const timeout = window.setTimeout(() => controller.abort(), 60000);
      const nextInit = { ...init, signal: controller.signal };
      return originalFetch(input, nextInit).finally(() => {
        window.clearTimeout(timeout);
        if (existingSignal) {
          existingSignal.removeEventListener("abort", abortFromExisting);
        }
      });
    };
  }

  const ensureStatus = () => {
    const button = document.getElementById("cropperBtn");
    if (!button) return null;
    let status = document.getElementById("ema-mpp-crop-status");
    if (!status) {
      status = document.createElement("div");
      status.id = "ema-mpp-crop-status";
      status.setAttribute("role", "status");
      status.setAttribute("aria-live", "polite");
      button.insertAdjacentElement("afterend", status);
    }
    return status;
  };

  let timers = [];
  const clearTimers = () => {
    timers.forEach((timer) => window.clearTimeout(timer));
    timers = [];
  };

  document.addEventListener(
    "click",
    (event) => {
      const button = event.target && event.target.closest && event.target.closest("#cropperBtn");
      if (!button) return;

      clearTimers();
      const status = ensureStatus();
      if (!status) return;
      status.classList.remove("is-visible");
      button.setAttribute("aria-busy", "true");

      timers.push(
        window.setTimeout(() => {
          status.innerHTML =
            "<strong>Préparation en cours.</strong> Votre visuel est en train d'être recadré. Le premier essai peut prendre jusqu'à une minute.";
          status.classList.add("is-visible");
        }, 12000)
      );

      timers.push(
        window.setTimeout(() => {
          status.innerHTML =
            "<strong>C'est presque prêt.</strong> Gardez cette page ouverte : le recadrage peut être plus lent lorsque le service se relance.";
          status.classList.add("is-visible");
        }, 45000)
      );
    },
    true
  );

  window.addEventListener("pageshow", () => {
    clearTimers();
    const button = document.getElementById("cropperBtn");
    if (button) button.removeAttribute("aria-busy");
  });
})();
